/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentProtocolEnum } from './ConversationalAgentProtocolEnum';
import {
  ConversationalAgentProtocolEnumFromJSON,
  ConversationalAgentProtocolEnumFromJSONTyped,
  ConversationalAgentProtocolEnumToJSON,
} from './ConversationalAgentProtocolEnum';

/**
 *
 * @export
 * @interface ConversationalAgentInferencerOpenAIAssistantCreate
 */
export interface ConversationalAgentInferencerOpenAIAssistantCreate {
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerOpenAIAssistantCreate
   */
  name: string;
  /**
   *
   * @type {ConversationalAgentProtocolEnum}
   * @memberof ConversationalAgentInferencerOpenAIAssistantCreate
   */
  protocol: ConversationalAgentProtocolEnum;
  /**
   *
   * @type {Date}
   * @memberof ConversationalAgentInferencerOpenAIAssistantCreate
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof ConversationalAgentInferencerOpenAIAssistantCreate
   */
  assistantId: string;
  /**
   *
   * @type {number}
   * @memberof ConversationalAgentInferencerOpenAIAssistantCreate
   */
  credentialId?: number | null;
}

/**
 * Check if a given object implements the ConversationalAgentInferencerOpenAIAssistantCreate interface.
 */
export function instanceOfConversationalAgentInferencerOpenAIAssistantCreate(
  value: object,
): value is ConversationalAgentInferencerOpenAIAssistantCreate {
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('assistantId' in value) || value['assistantId'] === undefined) return false;
  return true;
}

export function ConversationalAgentInferencerOpenAIAssistantCreateFromJSON(
  json: any,
): ConversationalAgentInferencerOpenAIAssistantCreate {
  return ConversationalAgentInferencerOpenAIAssistantCreateFromJSONTyped(json, false);
}

export function ConversationalAgentInferencerOpenAIAssistantCreateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentInferencerOpenAIAssistantCreate {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'],
    protocol: ConversationalAgentProtocolEnumFromJSON(json['protocol']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    assistantId: json['assistant_id'],
    credentialId: json['credential_id'] == null ? undefined : json['credential_id'],
  };
}

export function ConversationalAgentInferencerOpenAIAssistantCreateToJSON(
  value?: ConversationalAgentInferencerOpenAIAssistantCreate | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    protocol: ConversationalAgentProtocolEnumToJSON(value['protocol']),
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    assistant_id: value['assistantId'],
    credential_id: value['credentialId'],
  };
}
